import React from 'react';
import Navigation from './Navigation';
import Hero from './Hero';
import Plans from './Plans';
import Benefits from './Benefits';
import HowItWorks from './HowItWorks';
import SocialImpact from './SocialImpact';
import Testimonials from './Testimonials';
import Coverage from './Coverage';
import Footer from './Footer';
const MainLanding = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-120">
      <Navigation data-id="element-121" />
      <main className="flex-grow" data-id="element-122">
        <Hero data-id="element-123" />
        <Plans data-id="element-124" />
        <Benefits data-id="element-125" />
        <HowItWorks data-id="element-126" />
        <SocialImpact data-id="element-127" />
        <Testimonials data-id="element-128" />
        <Coverage data-id="element-129" />
      </main>
      <Footer data-id="element-130" />
    </div>;
};
export default MainLanding;